<template>
  <div class="app-container">
    <div class="top_item">
      <div class="add_cate"
        @click="addAccount">添加系统账号</div>
      <div class="search_export search"
        @click="exportAccount">导出</div>
      <div class="search_rest search"
        @click="resetAccount">重置</div>
      <div class="search"
        @click="callAccount">查询</div>
      <el-input placeholder="输入用户账号搜索"
        size="mini"
        v-model="form.account"
        style="float:right;width:160px;margin-right:4px;margin-top:-18px;"></el-input>
      <span style="float:right;margin-top:-18px;margin-right:4px;color:#666">账号搜索</span>
      <el-input placeholder="输入用户名称关键词"
        size="mini"
        v-model="form.nickname"
        style="float:right;width:160px;margin-right:4px;margin-top:-18px;"></el-input>
      <span style="float:right;margin-top:-18px;margin-right:4px;color:#666">关键词搜索</span>
    </div>

    <el-table :data="tableData"
      border
      max-height="600"
      size="mini"
      style="width: 100%"
      :cell-style="tc"
      :header-cell-style="tc"
      @selection-change="handleSelectionChange"
      v-loading="listLoading">
      <el-table-column type="selection"
        width="55"> </el-table-column>
      <el-table-column label="账号ID"
        prop="id"></el-table-column>
      <el-table-column label="账号名称"
        prop="nickname"></el-table-column>
      <el-table-column label="登陆账号"
        prop="account"></el-table-column>
      <el-table-column label="权限组">
        <template slot-scope="scope">
          <p v-if="scope.row.is_root == 1">默认</p>
        </template>
      </el-table-column>
      <el-table-column label="账号状态">
        <template slot-scope="scope">
          <div class="account_status_start"
            v-if="scope.row.status == 0">●</div>
          <div class="account_status_end"
            v-else>●</div>
          <span v-if="scope.row.status == 0">已启用</span>
          <span v-else>已禁用</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间"
        prop="created_at"
        width="136"></el-table-column>
      <el-table-column label="操作"
        fixed="right"
        width="320">
        <template slot-scope="scope">
          <el-button size="mini"
            @click="resetpassword(scope.row.id)">密码重置</el-button>
          <el-button size="mini"
            type="success"
            v-if="scope.row.status == 0"
            @click="disabledAccount(scope.row.id, 1)">禁用</el-button>
          <el-button size="mini"
            type="info"
            v-else
            @click="disabledAccount(scope.row.id, 0)">启用</el-button>
          <el-button size="mini"
            type="warning"
            @click="editAccount(scope.row)">编辑</el-button>
          <el-button size="mini"
            type="danger"
            @click="deleteAccount(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row v-show="total > 0">
      <el-col :span="8"
        style="padding:12px 0;">
        <el-button :disabled="selectedList.length === 0"
          type="success"
          size="small"
          @click="batchToDelete">批量删除</el-button>
        <el-button :disabled="selectedList.length === 0"
          type="danger"
          size="small"
          @click="disableAllSelect">批量禁用</el-button>
      </el-col>
      <el-col :span="20">
        <div class="pagination">
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="pageChange"
            :current-page="form.page"
            :page-sizes="[20, 50, 100]"
            :page-size="form.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <gydialog :title="title"
      :visible.sync="showAddOrEdit"
      width="540px;">
      <div style="padding:20px 30px;">
        <table class="accountinfo"
          border="1">
          <tr>
            <td class="left_account">
              <div>账号名称</div>
            </td>
            <td>
              <el-input size="mini"
                style="width:240px;float:left;margin-left:24px;"
                v-model="editForm.nickname"
                placeholder="请输入账户名称"></el-input>
            </td>
          </tr>
          <tr>
            <td class="left_account">
              <div>登陆账号</div>
            </td>
            <td>
              <el-input size="mini"
                style="width:240px;float:left;;margin-left:24px;"
                v-model="editForm.account"
                placeholder="请输入登陆账号"></el-input>
            </td>
          </tr>
          <tr>
            <td class="left_account">
              <div>登陆密码</div>
            </td>
            <td v-if="title == '添加系统账户'">
              <el-input size="mini"
                style="width:240px;float:left;;margin-left:24px;"
                v-model="editForm.password"
                placeholder="不设置密码按系统默认密码生效"></el-input>
            </td>
            <td v-else>
              <el-button size="mini"
                @click="resetpassword(scope.row.id)"
                style="float:left;margin-left:24px;"
                disabled>密码重置</el-button>
            </td>
          </tr>
        </table>

        <div style="text-align:center;padding:20px;">
          <el-button size="mini"
            @click="cancelShowAccount">取消</el-button>
          <el-button size="mini"
            type="warning"
            @click="addEditAccount">确定</el-button>
        </div>
      </div>
    </gydialog>
  </div>
</template>

<script>
import {
  sysAccountList,
  sysCreateAccount,
  initAccountPassword,
  batchUpdateStatus,
  updateAccountInfo,
  batchDelete,
  exportAdminAccounts
} from '@/api/account'
import { BASE_API } from '@/config'
export default {
  data () {
    return {
      title: '添加系统账户',
      tableData: [],
      total: 0,
      listLoading: false,
      selectedList: [],
      form: {
        page_size: 20,
        page: 1,
        account: '',
        nickname: ''
      },
      showAddOrEdit: false,
      editForm: {
        account: '',
        password: '',
        nickname: ''
      },
      editId: ''
    }
  },
  activated () {
    this.listLoading = true
    this.sysAccountListData()
  },
  methods: {
    //添加系统账号
    addAccount () {
      this.title = '添加系统账户'
      this.showAddOrEdit = true
    },
    //编辑用户
    editAccount (row) {
      this.title = '编辑系统账户'
      this.showAddOrEdit = true
      this.editForm.account = row.account
      this.editForm.nickname = row.nickname
      this.editForm.password = row.password
      this.editId = row.id
    },
    //导出
    exportAccount () {

      exportAdminAccounts({ account: this.form.account, nickname: this.form.nickname }).then(res => {
        window.open(`${BASE_API}/admin/download/zip/${res[1].download_token}`)
      })
    },
    //重置
    resetAccount () {
      this.form.account = ''
      this.form.nickname = ''
    },
    //查询
    callAccount () {
      this.form.page = 1
      this.sysAccountListData()
    },
    handleSizeChange (val) {
      this.form.size = val
      this.pageChange(1)
    },
    pageChange (page) {
      this.form.page = page
      this.sysAccountListData()
    },
    batchToDelete () {
      this.$confirm('确定删除账户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const selectedList = this.selectedList
          if (selectedList.length > 0) {
            const arr = []
            selectedList.forEach(item => {
              arr.push(item.id)
            })
            this.batchDeleteData(arr.join('|'))
          }
        })
        .catch(() => {
          console.log('cancel')
        })
    },
    disableAllSelect () {
      this.$confirm('确定禁用账户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const selectedList = this.selectedList
        if (selectedList.length > 0) {
          const arr = []
          selectedList.forEach(item => {
            arr.push(item.id)
          })
          this.batchUpdateStatusData(arr.join('|'), 1)
        }
      })
    },
    cancelShowAccount () {
      this.showAddOrEdit = false
      this.editForm = {
        account: '',
        password: '',
        nickname: ''
      }
    },
    addEditAccount () {
      if (!this.editForm.nickname) {
        this.$message.error('账户昵称不能为空')
        return
      }

      if (!this.editForm.account) {
        this.$message.error('账户昵称不能为空')
        return
      }


      if (this.editForm.password.length < 6) {
        this.$message.error('密码位数不能小于6位')
        return
      }

      if (this.title == '添加系统账户') {
        this.sysCreateAccountData()
      } else {
        this.updateAccountInfoData()
      }
    },
    //获取用户列表
    async sysAccountListData () {
      let res = await sysAccountList(this.form)
      this.listLoading = false

      this.tableData = res.data
      this.total = res.total
    },
    //添加新账户
    async sysCreateAccountData () {
      if (!this.editForm.password) {
        this.editForm.password = '888888'
      }
      let res = await sysCreateAccount(this.editForm)
      console.log(res)
      this.$message.success('创建账号成功')
      this.cancelShowAccount()
      this.pageChange(1)
    },

    //更新用户信息
    async updateAccountInfoData () {
      let res = await updateAccountInfo(this.editId, this.editForm)
      console.log(res)
      this.$message.success('更新用户信息成功')
      this.cancelShowAccount()
      this.pageChange(1)
    },
    //禁用账户
    disabledAccount (id, type) {
      this.batchUpdateStatusData(id, type)
    },
    async batchUpdateStatusData (id, type) {
      var form = {
        ids: id,
        status: type
      }
      let res = await batchUpdateStatus(form)
      console.log(res)
      this.$message.success('禁用账户成功')
      this.sysAccountListData()
    },
    //重置密码
    resetpassword (id) {
      this.$confirm('确定重置密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.initAccountPasswordData(id)
        })
        .catch(() => {
          console.log('cancel')
        })
    },
    async initAccountPasswordData (id) {
      let res = await initAccountPassword(id, { id: id })
      console.log(res)
      this.$message.success('密码重置成功')
    },
    //删除用户
    deleteAccount (id) {
      this.$confirm('确定删除账户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.batchDeleteData(id)
        })
        .catch(() => {
          console.log('cancel')
        })
    },
    async batchDeleteData (ids) {
      let res = await batchDelete({ ids: ids })
      console.log(res)
      this.$message.success('删除账号成功')
      this.sysAccountListData()
    },
    tc () {
      return 'text-align:center;'
    },
    handleSelectionChange (arr) {
      this.selectedList = arr
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
	padding: 20px;
	background-color: #fff;
}
.top_item {
	background-color: #fff;
	border-radius: 4px;
	height: 64px;
	line-height: 64px;
}
.add_cate {
	float: left;
	width: 100px;
	height: 30px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 30px;
	border-radius: 4px;
	cursor: pointer;
}

.search {
	float: right;
	width: 64px;
	margin-left: 6px;
	height: 28px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 28px;
	border-radius: 4px;
	cursor: pointer;
}
.search_export {
	background-color: #3498d8;
}
.search_rest {
	background-color: #67c23a;
}
.account_status_start {
	color: #67c23a;
	float: left;
	width: 4px;
	padding-left: 16px;
	text-align: center;
	border-radius: 50%;
}
.account_status_end {
	color: #f4222d;
	float: left;
	width: 4px;
	padding-left: 16px;
	text-align: center;
	border-radius: 50%;
}
.accountinfo {
	border-width: 1px;
	border-color: rgb(228, 228, 228);
	border-collapse: collapse;
	width: 100%;
	tr {
		height: 40px;
	}
}
.left_account {
	background-color: rgb(249, 250, 252);
	color: #333;
	font-size: 14px;
}
</style>
